module.exports = __webpack_public_path__ + "media/img/frontend_application/noroom-ebe7d27013e568fcea61d82e75e2baff.png";